import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './sideBar.css';
import {
  Icon,
  Label,
  Grid,
  Menu,
  Segment,
  Sidebar,
  Button,
  Dimmer
} from 'semantic-ui-react';
import { getCDNpath } from '../../../app/common/util';
import { changeRoute } from './SideBarActions';
import { BrowserView, MobileView, TabletView } from 'react-device-detect';
import MobileHeader from '../../MobileHeader';

const fcLogo = getCDNpath('/static/images/freechargeLogo.png');

const NavLinkModified = props => {
  return (
    <React.Fragment>
      <NavLink {...props} activeClassName="navactive" />
    </React.Fragment>
  );
};

const mapState = state => ({
  isLoggedIn: (state.auth.isLoggedIn && state.auth.isLoggedIn.result) || false,
  storedCards:
    state.cards && state.cards.fetchedCards && state.cards.fetchedCards.cards,
  bankAccounts: state.bank && state.bank.get && state.bank.get.data,
  activeRoute: state.sidebar && state.sidebar.activeRoute
});

const actions = {
  changeRoute
};

class SideBarContainer extends Component {
  static propTypes = {
    activeRoute: PropTypes.string,
    storedCards: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    bankAccounts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    changeRoute: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
  };

  state = {
    showSidebar: false
  };

  handleItemClick = (e, { name }) => {
    this.props.changeRoute(name);
    this.toggleSideBar();
  };

  toggleSideBar = () => {
    this.setState({
      showSidebar: !this.state.showSidebar
    });
  };

  render() {
    const { bankAccounts, children, storedCards, activeRoute } = this.props;

    const menu = (
      <Menu vertical borderless floated fixed="left" stackable>
        <Menu.Item
          // active={activeRoute === 'dashboard'}
          as={NavLinkModified}
          to="/accounts/dashboard"
          onClick={this.handleItemClick}
          name="dashboard"
          className=""
          color="orange"
        >
          <img id="fcLogo" src={fcLogo} alt="Freecharge" />
        </Menu.Item>
        <Menu.Item
          name="cash"
          as="a"
          className="fc-icon"
          onClick={() => {
            window.location.href = 'https://freecharge.in/'
          }}
        >
          Freecharge Home
        </Menu.Item>
        <Menu.Item
          name="cash"
          active={activeRoute === 'cash'}
          as={NavLinkModified}
          to="/accounts/cash"
          onClick={this.handleItemClick}
        >
          <span className="sprite cash">Add money</span>
        </Menu.Item>
        <Menu.Item
          name="limits"
          active={activeRoute === 'limits'}
          as={NavLinkModified}
          to="/accounts/limits"
          onClick={this.handleItemClick}
        >
          <span className="sprite limits">Transaction Limits</span>
        </Menu.Item>
        <Menu.Item
          name="storedCards"
          active={activeRoute === 'storedCards'}
          as={NavLinkModified}
          to="/accounts/stored"
          onClick={this.handleItemClick}
        >
          {storedCards && <Label color="grey">{storedCards.length}</Label>}
          <span className="sprite cards">Saved Cards</span>
        </Menu.Item>
        <Menu.Item
          name="banks"
          active={activeRoute === 'banks'}
          as={NavLinkModified}
          to="/accounts/banks"
          onClick={this.handleItemClick}
        >
          {bankAccounts && Array.isArray(bankAccounts) && (
            <Label color="grey">{bankAccounts.length}</Label>
          )}
          <span className="sprite banks">Bank Accounts</span>
        </Menu.Item>
        <Menu.Item
          name="statement"
          active={activeRoute === 'statement'}
          as={NavLinkModified}
          to="/accounts/statement"
          onClick={this.handleItemClick}
        >
          <span className="sprite wallet">Wallet Statement</span>
        </Menu.Item>
        <Menu.Item
          name="profile"
          active={activeRoute === 'profile'}
          as={NavLinkModified}
          to="/accounts/profile"
          onClick={this.handleItemClick}
        >
          <span className="sprite profile">Profile</span>
        </Menu.Item>
      </Menu>
    );

    const tabAndMobView = (
      <Sidebar.Pushable id="mainSidebar">
        <Sidebar
          as={Menu}
          animation="push"
          icon="labeled"
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={this.state.showSidebar}
          width="thin"
          direction="left"
          id="horSidebar"
        >
          {menu}
        </Sidebar>

        <Sidebar.Pusher>
          <MobileHeader>
            <Button
              icon
              onClick={this.toggleSideBar}
              style={{ marginLeft: this.state.showSidebar ? '70px' : '0' }}
              className="toggleSidebarBtn mobile only"
            >
              <Icon name="bars" />
            </Button>
            <Dimmer
              active={this.state.showSidebar}
              onClickOutside={this.toggleSideBar}
            />
            <Segment basic>{children}</Segment>
          </MobileHeader>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    );

    return (
      <React.Fragment>
        <BrowserView>
          <div id="mainSidebar">
            <Grid stackable>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Sidebar
                    as={Menu}
                    animation="push"
                    icon="labeled"
                    inverted
                    onHide={this.handleSidebarHide}
                    vertical
                    visible={true}
                    width="thin"
                    direction="left"
                    id="horSidebar"
                  >
                    {menu}
                  </Sidebar>
                </Grid.Column>
                <Grid.Column width={12}>
                  <br />
                  {children}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </BrowserView>

        <MobileView>{tabAndMobView}</MobileView>

        <TabletView>{tabAndMobView}</TabletView>
      </React.Fragment>
    );
  }

  componentDidUpdate() {
    this.route = window.location.pathname.split('/')[1];
  }
}

export default connect(
  mapState,
  actions
)(SideBarContainer);
